module.exports = __webpack_public_path__ + "img/spiris.dfc85008.png";